import { useState, useEffect } from "react";

import { useQuery } from "@tanstack/react-query";

import { searchCompanies } from "../api/executiveCompanyApi";
import type { ExecutiveCompanyOption } from "../types/ExecutiveCompanyOption.type";

interface UseCompanySearchResult {
	companies: ExecutiveCompanyOption[];
	isLoading: boolean;
	isError: boolean;
	setSearchTerm: (term: string) => void;
	searchTerm: string;
}

export const useCompanySearch = (): UseCompanySearchResult => {
	const [searchTerm, setSearchTerm] = useState("");
	const [debouncedTerm, setDebouncedTerm] = useState("");

	useEffect(() => {
		const timerId = setTimeout(() => {
			setDebouncedTerm(searchTerm);
		}, 250);

		return () => {
			clearTimeout(timerId);
		};
	}, [searchTerm]);

	const { data, isLoading, isError } = useQuery({
		queryKey: ["executive", "companies", debouncedTerm],
		queryFn: () => searchCompanies(debouncedTerm),
		enabled: debouncedTerm.length >= 2,
		staleTime: 30 * 1000,
		select: (response) => response.data.data,
	});

	return {
		companies: data ?? [],
		isLoading,
		isError,
		setSearchTerm,
		searchTerm,
	};
};
